import { EquipmentItemTypeSchema } from '@standandforce/api-contract';
import { z } from 'zod';
import { EquipmentStatusSchema } from '@/features/equipment/-constants';
import { optionalStringArraySearchSchema } from '@/lib/optionalStringArraySearchSchema';
export const equipmentListFilterFields = {
  status: EquipmentStatusSchema.default('ALL'),
  freeText: z.string().optional(),
  equipmentTypeIdIn: optionalStringArraySearchSchema,
  equipmentItemIdIn: optionalStringArraySearchSchema,
  itemTypeIn: z.array(EquipmentItemTypeSchema).optional(),
  placementPlaceIdIn: optionalStringArraySearchSchema,
  warehousingPlaceIdIn: optionalStringArraySearchSchema
};